import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import { FormControlLabel } from '@material-ui/core';
import { Spinner, Switch } from '../../common/components';
import messages from '../messages';

const S = {
  FormControlLabel: styled(({ classes, ...otherProps }) => (
    <FormControlLabel
      classes={{
        ...classes,
        label: 'label',
      }}
      {...otherProps}
    />
  ))`
    margin-right: 4px;
    .label {
      color: ${({ checked, theme }) => (checked ? theme.palette.grey[800] : theme.palette.error.main)};
      font-size: ${({ theme }) => theme.typography.pxToRem(15)};
      font-weight: 500;
      text-align: right;
      transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
  `,
};

const StatusSwitcher = ({
  activeStatus, checked, intl, onChange,
}) => (
  <>
    <S.FormControlLabel
      control={<Switch color="secondary" />}
      label={intl.formatMessage(messages[`statusSwitcherLabel${checked ? 'Ongoing' : 'Closed'}`])}
      labelPlacement="start"
      checked={checked}
      onChange={onChange}
    />
    {activeStatus.loading && <Spinner />}
  </>
);

StatusSwitcher.propTypes = {
  activeStatus: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }),
  checked: PropTypes.bool.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

StatusSwitcher.defaultProps = {
  activeStatus: { loading: false },
};

export default injectIntl(StatusSwitcher);
